/**
 * @voltxampere/presets — Digital AND gate demo (Sprint 50-5)
 *
 * 2-input AND gate driven by two voltage sources at TTL levels.
 * With both inputs HIGH (5V), output goes HIGH; if either input is
 * LOW, output is LOW. Uses the Sprint 41 canonical `digital-gate`
 * stamp (gateFunction = "AND").
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { makeCircuit, makeNet, makeComponent } from "../_builders.js";
export const digitalAndGate = {
    id: "digital-and-gate",
    name: { tr: "Dijital VE Kapısı", en: "Digital AND Gate" },
    category: "digital",
    difficulty: 1,
    description: {
        tr: "2-girişli VE kapısı. İki giriş HIGH ise çıkış HIGH (5V).",
        en: "2-input AND gate. Output HIGH (5V) when both inputs are HIGH.",
    },
    circuit: makeCircuit({
        slot: 1,
        name: "Digital AND Gate",
        description: "2-input AND with both inputs high",
        nets: [
            makeNet({ name: "gnd", isGround: true }),
            makeNet({ name: "in1" }),
            makeNet({ name: "in2" }),
            makeNet({ name: "out" }),
        ],
        components: [
            makeComponent({
                id: "V_IN1",
                type: "voltage-source",
                params: { voltage: 5 },
                terminals: { pos: "net_in1", neg: "net_gnd" },
                label: "V_IN1",
                position: { x: -160, y: -60 },
                rotation: 0,
            }),
            makeComponent({
                id: "V_IN2",
                type: "voltage-source",
                params: { voltage: 5 },
                terminals: { pos: "net_in2", neg: "net_gnd" },
                label: "V_IN2",
                position: { x: -160, y: 60 },
                rotation: 0,
            }),
            makeComponent({
                id: "U1",
                type: "digital-gate",
                params: { gateFunction: "AND", vHigh: 5, vLow: 0, threshold: 2.5 },
                terminals: { in1: "net_in1", in2: "net_in2", out: "net_out" },
                label: "U1",
                position: { x: 0, y: 0 },
                rotation: 0,
            }),
            makeComponent({
                id: "GND1",
                type: "ground",
                params: {},
                terminals: { p: "net_gnd" },
                position: { x: -160, y: 80 },
                rotation: 0,
            }),
        ],
        wires: [],
    }),
    expectedValues: [
        {
            node: "out",
            analysis: "dc",
            value: 5,
            tolerance: 0.001,
            unit: "V",
        },
    ],
    learningGoals: [
        {
            tr: "VE doğruluk tablosu: 1·1=1, hepsi diğer kombinasyonlar 0.",
            en: "AND truth table: 1·1=1; all other combinations are 0.",
        },
        {
            tr: "Threshold-based digital simulation eşiği 2.5V.",
            en: "Threshold-based digital simulation threshold at 2.5V.",
        },
    ],
    references: ["Sedra/Smith, Microelectronic Circuits, Ch. 14"],
};
//# sourceMappingURL=digital-and-gate.js.map